import * as React from 'react';
import { Header, Table } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';
import { EmptyState } from 'src/commons/EmptyState';
import { TemplateResult } from 'aws-sdk/clients/awsdatalakegladstonelambda';

export interface TemplatesForResourceDetailsTableProps {
  items: any[];
  userOwnsResource: boolean;
  loading?: boolean;
}

export const TemplatesForResourceDetailsTable = (props: TemplatesForResourceDetailsTableProps) => {
  return (
    <Table
      loadingText='Loading templates'
      columnDefinitions={templateColumnDefinitions(props.userOwnsResource)}
      items={props.items}
      resizableColumns
      header={<Header counter={`(${props.items?.length ?? 0})`}>Templates</Header>}
      loading={!!props.loading}
      empty={<EmptyState title={'No templates'} subtitle={'No templates were found for the resource.'} />}
    />
  );
};

const NONE = '-';

const simTemplateLinkForTemplate = (item: TemplateResult) => {
  if (item?.accessManagementInfo?.simTemplates?.[0]?.simTemplateLink) {
    return (
      <Link href={item.accessManagementInfo?.simTemplates?.[0]?.simTemplateLink} external={true}>
        {'SIM template link'}
      </Link>
    );
  } else {
    return NONE;
  }
};

const approvalTemplateLinkForTemplate = (item: TemplateResult) => {
  if (item.accessRequestWorkflows?.[0]?.approvalsWorkflowTemplate?.approvalTemplateLink) {
    return (
      <Link href={item.accessRequestWorkflows?.[0]?.approvalsWorkflowTemplate?.approvalTemplateLink} external={true}>
        {'Approval template link'}
      </Link>
    );
  } else if (item?.accessManagementInfo?.approvalsWorkflowTemplate?.approvalTemplateLink) {
    return (
      <Link href={item.accessManagementInfo?.approvalsWorkflowTemplate?.approvalTemplateLink} external={true}>
        {'Approval template link'}
      </Link>
    );
  } else {
    return NONE;
  }
};

const templateColumnDefinitions = (userOwnsResource: boolean) => [
  {
    id: 'templateName',
    header: 'Name',
    cell: (item) =>
      userOwnsResource ? (
        <Link href={`/templates/${item.templateId}/${item.resourceId}`}>{item.name.split()}</Link>
      ) : (
        item.name.split()
      ),
    minWidth: 200,
    sortingField: 'templateName',
  },
  {
    id: 'description',
    header: 'Description',
    cell: (item) => item.description,
    minWidth: 200,
  },
  {
    id: 'ownerId',
    header: 'Owner',
    cell: (item) => item.ownerId,
    minWidth: 200,
  },
  {
    id: 'simTemplateLink',
    header: 'SIM template link',
    cell: (item: TemplateResult) => simTemplateLinkForTemplate(item),
    minWidth: 200,
  },
  {
    id: 'approvalTemplateLink',
    header: 'Approval template link',
    cell: (item: TemplateResult) => approvalTemplateLinkForTemplate(item),
    minWidth: 200,
  },
];
